// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"39eb4e3f","878":"fbdd6c75"}[chunkId] + ".chunk.js";
};